import React, { Suspense, lazy, useEffect, useState } from "react";
import {
  Chip,
  Accordion, AccordionDetails, AccordionSummary,
  Grid,
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  TextField,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
  Modal,
  Box,
  IconButton,
  CircularProgress,
  Backdrop,
  Container,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
} from "@mui/material";
import { Theme, useTheme } from '@mui/material/styles'
import { createStyles, makeStyles } from '@mui/styles';
import ResponsiveDrawer from "src/components/ClippedResponsiveDrawer";
import { useLocalStorage } from "src/utils/LocalStorageHook";
import { getPlants, getTelemeterdata } from "src/utils/Telemeter";
import { GridColumns, GridFilterInputValue, GridFilterItem, GridFilterModel, GridLinkOperator, GridSortModel, GridToolbarColumnsButton, GridToolbarContainer, GridToolbarDensitySelector, GridToolbarExport, GridToolbarFilterButton } from "@mui/x-data-grid-pro";
import { Clear, Search, SearchOff } from "@mui/icons-material";
import TelemeterAbstractionTable from "./components/TelemeterTable";

const useStyles = makeStyles((theme: Theme) => ({
  root: {},
  container: {

  },
error:{
  color:"#e9232a"
}
  

}));

interface OSearch {
  enabled: boolean, // does one or more column allow this type of search? 
  searching?: boolean, // is the user searching? 
  text?: string // what is the user searching for?
}

export function TelemeterDashboard() {
  let classes = useStyles();
  let [data, setData] = useState<any[]>([]);
  let [backdropLoader, setBackdropLoader] = React.useState<boolean>(false);
  let [salesOrg] = useLocalStorage("SETTINGS.salesOrg", "");
  let key = 'VS_DEX';
  let [omniSearch, setOmniSearch] = useState<OSearch>({ enabled: false });
  let [plantList, setPlant] = useState([]);
  let [plantName, setPlantName] = React.useState<string[]>([]);
  let [open, setOpen] = React.useState<boolean>(false);
  let [confirmResetFilter, setConfirmResetFilter] = useState<boolean>(false);
  let [is_resetFilter, setIs_resetFilter] = useState<boolean>(false);
  useEffect(() => {
    if (salesOrg) {

      fetchPlants()
    }
  }, [salesOrg])

  function fetchPlants (){
    getPlants(salesOrg, false).then(async (resp: any) => {
      if (resp.length > 0) {
        setPlant(resp)
        let value = resp[0]?.code;
        setPlantName(typeof value === "string" ? value.split(",") : value);
         fetchTelemeterdata([value])


      }
    })
  }

  function fetchTelemeterdata (plant: any)  {
    setBackdropLoader(true)
    if (salesOrg) {
   
      getTelemeterdata(salesOrg, plant).then((res: any) => {
        setData(res);
        setBackdropLoader(false)
      })
    }
  }

  const customToolbar = (title?: string, save?: any) => {
    let timeout: NodeJS.Timeout;
    let text = '';

    function enableSearch(searching: boolean) {
      setOmniSearch({ ...omniSearch, searching, text: undefined })
    }
    function setSearch(ce: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) {
      text = ce.target.value || ''
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        setOmniSearch({ ...omniSearch, text })
      }, 3000)
    }

    return (
      <>
        <GridToolbarContainer key={key + "toolbar"} style={{ position: 'absolute', right: 0 }}>
          <Select
            labelId="Plant"
            multiple
            onChange={selectedPlant}
            open={open}
            onClose={() => setOpen(false)}
            onOpen={() => setOpen(true)}
            value={plantName}
            renderValue={(selected) => selected.join(', ')}
            style={{ height: "55px", width: "200px", marginLeft: "auto" }}
          >
            {plantList.map((item: any) => (
              item?.code !== 'ALL' ?
                <MenuItem value={item?.code}>
                  <ListItemText primary={item?.code + '-' + item?.text} />
                </MenuItem> : ''
            ))}
          </Select>
          <Dialog
            open={confirmResetFilter}
            onClose={() => setConfirmResetFilter(false)}
          >
            <DialogTitle>Confirm Reset Filters</DialogTitle>
            <DialogContent>
              <DialogContentText>
                Column filters will be reset. Are you sure you wish to continue ?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => { setIs_resetFilter(true); setConfirmResetFilter(false); }} color="primary">
                Yes
              </Button>
              <Button onClick={() => { setConfirmResetFilter(false); }} color="primary" autoFocus>
                No
              </Button>
            </DialogActions>
          </Dialog>

        </GridToolbarContainer>

      </>
    );

  };

  const selectedPlant = (event: any, child: any) => {
    const { target: { value } } = event;
    setOpen(false);
    setPlantName([child.props.value]);
    fetchTelemeterdata([child.props.value])
  }

  let columns: any = [
    {
      label: "Plant",
      name: "delivering_plant",
      options: {
        filter: true,
        searchable: true,
        hint: "Delivery Plant Number",
      },
    },
    {
      label: "Plant Name",
      name: "plant_name",
      options: {
        hint: "Delivery Plant Name",
        filter: true,
        searchable: true,
      },
    },
    {
      label: "Cust Num",
      name: "customer_num",
      options: {
        hint: "Customer Number",
        filter: true,
        searchable: true,
        renderCell: (params: any) => (
          <Chip
            label={params.value as any}
            variant="outlined"
            size="small"
            clickable={true}
            onClick={() => window.open(`/customer/${params.value as any}?tab=6`, "_blank")}
          />
        ),
      },
    },

    {
      label: "Cust Name",
      name: "customer_name",
      options: {
        hint: "Customer Number",
        filter: true,
        searchable: true,
      },
    },
    {
      label: "Equip",
      name: "equipment_num",
      options: {
        hint: ":Equipment Number",
        filter: true,
        searchable: true,
      },
    },
    {
      label: "Asset",
      name: "asset",
      options: {
        hint: "Asset Num",
        filter: true,
        searchable: true,
      },
    },

    {
      label: "Sub Ser",
      name: "sub_serial_num",
      options: {
        hint: "Sub serial number",
        filter: true,
        searchable: true,
      },
    },
    {
      label: "Ds LA ",
      name: "dsla",
      options: {
        hint: "Days Since Last Audit: Num of days since last telemeter push came(processed/ non processed)",
        filter: true,
        searchable: true,
      },
    },

    {
      label: "Last Audit",
      name: "last_audit",
      options: {
        hint: ": Date last telemeter push came(processed/ non processed)",
        filter: true,
        searchable: true,
      },
    },

    {
      label: "Ds DEX",
      name: "dsdex",
      options: {
        hint: "Days since Last DEX: Num of days since last valid processed DEX telemeter push",
        filter: true,
        searchable: true,
      },
    },

    {
      label: "Last DEX",
      name: "last_dex",
      options: {
        hint: " Date last valid processed DEX telemeter push came",
        filter: true,
        searchable: true,
      },
    },
    {
      label: "Ds FK ",
      name: "dfk",
      options: {
        hint: "Num of days since last Fill Key Dex came.(valid processed)",
        filter: true,
        searchable: true,
      },
    },


    {
      label: "Last FK",
      name: "last_fill",

      options: {
        hint: "Date last fill key came(valid processed)",
        filter: true,
        searchable: true,
      },
    },

    {
      label: "Model ",
      name: "model",
      options: {
        hint: "Equipment Model",
        filter: true,
        searchable: true,
      },
    },
    {
      label: "Last Event",
      name: "last_event",
      options: {
        hint: "Last received Event Type",
        filter: true,
        searchable: true,
      },
    },
    {
      label: "Location",
      name: "location",
      options: {
        hint: "Customer Location",
        filter: true,
        searchable: true,
      },
    },


    {
      label: "BJ",
      name: "bj",
      options: {
        hint: "BILL VALIDATOR JAMMED",
        filter: true,
      renderCell: (params: any) => (
        <span className={params.value=='YES'?classes.error:''}> {params.value} </span>
      
      )}
    },
    {
      label: "BOPN ",
      name: "bopn",
      options: {
        hint: "BILL VALIDATOR STACKER IS OPEN OR OUT OF POSITION",
        filter: true,
        searchable: true,
        renderCell: (params: any) => (
          <span className={params.value=='YES'?classes.error:''}> {params.value} </span>
        
        )}
    },

    {
      label: "CJ ",
      name: "cj",
      options: {
        hint: "COLUMN JAM IN COLUMN",
        filter: true,
        searchable: true,
        renderCell: (params: any) => (
          <span className={params.value=='YES'?classes.error:''}> {params.value} </span>
        
        )}
    },
    {
      label: "IC ",
      name: "ic",
      options: {
        hint: "CHANGER INLET CHUTE BLOCKED",
        filter: true,
        searchable: true,
        renderCell: (params: any) => (
          <span className={params.value=='YES'?classes.error:''}> {params.value} </span>
        
        )}
    },
    {
      label: "MAP ",
      name: "map",
      options: {
        hint: "COLUMN ASSIGNMENT MISMATCH",
        filter: true,
        searchable: true,
        renderCell: (params: any) => (
          <span className={params.value=='YES'?classes.error:''}> {params.value} </span>
        
        )}
    },
    {
      label: "MM ",
      name: "mm",
      options: {
        hint: "MATERIAL MISMATCH",
        filter: true,
        searchable: true,
        renderCell: (params: any) => (
          <span className={params.value=='YES'?classes.error:''}> {params.value} </span>
        
        )}
    },
    {
      label: "NFK ",
      name: "nfk",
      options: {
        hint: "NO FILL KEY",
        filter: true,
        searchable: true,
        renderCell: (params: any) => (
          <span className={params.value=='YES'?classes.error:''}> {params.value} </span>
        
        )}
    }
    ,
    {
      label: "NJ ",
      name: "nj",
      options: {
        hint: "COIN JAM",
        filter: true,
        searchable: true,
        renderCell: (params: any) => (
          <span className={params.value=='YES'?classes.error:''}> {params.value} </span>
        
        )}
    }
    ,
    {
      label: "PRC ",
      name: "prc",
      options: {
        hint: "PRICING MISMATCH",
        filter: true,
        searchable: true,
        renderCell: (params: any) => (
          <span className={params.value=='YES'?classes.error:''}> {params.value} </span>
        
        )}
    }
    ,
    {
      label: "TJ ",
      name: "tj",
      options: {
        hint: "TUBE PAY OUT JAM IN COIN TYPE",
        filter: true,
        searchable: true,
        renderCell: (params: any) => (
          <span className={params.value=='YES'?classes.error:''}> {params.value} </span>
        
        )}
    }
    ,
    {
      label: "Swipe Model",
      name: "swipe",
      options: {
        hint: "Swipe Config Model. Currently it will be present as a placeholder. On hover shows value “For future use”",
        filter: true,
        searchable: true,
      },
    },
  ]

  return (<>
    <ResponsiveDrawer title="Telemeter Dashboard">
      <Container maxWidth={false} className={classes.container}>
        {/* <TelemeterTable  settingsKey= {key} rowdata={data} rowColum={columns} customToolbar={CustomToolbar} filters={is_resetFilter} /> */}

        <TelemeterAbstractionTable settingsKey={key}
          options={{
            serverSide: false,
            responsive: "standard",
            selectableRows: "none",
            //rowsPerPage,
            rowsPerPageOptions: [200, 500, 1000],
            draggableColumns: { enabled: true },
            fixedHeader: true,
            print: false,
            disableFuzySearch: true,
            tableHeightReducePx: 100,
            customToolbar,
            download: true,

          }}
          downloadFileName={"TelemeterDashboard"}
          columns={columns}
          data={data}
        />
      </Container>
    </ResponsiveDrawer>
    <Backdrop sx={{ color: "#fff", zIndex: (theme: any) => theme.zIndex.drawer + 1 }} open={backdropLoader}>
      <CircularProgress color="primary" />
    </Backdrop>
  </>)

}
